module.exports = "/static/Images/images/logo-default.png";